import { render } from "./Icons.vue?vue&type=template&id=b183a0d6"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/icons/Icons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b183a0d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b183a0d6', __exports__)) {
    api.reload('b183a0d6', __exports__)
  }
  
  module.hot.accept("./Icons.vue?vue&type=template&id=b183a0d6", () => {
    api.rerender('b183a0d6', render)
  })

}


export default __exports__